/**
 * Keep the Hero image eager for LCP, then retire its soft decode placeholder
 * only after image data is ready. A cached image resolves immediately.
 *
 * Non-module classic script (see the `<script>` tag in sections/home-hero.liquid),
 * so no ESM `export` here — matches assets/image-reveal.js otherwise.
 */
/** @param {Document | Element} root */
function enableHeroMedia(root = document) {
  /** @type {NodeListOf<HTMLImageElement>} */
  const heroImages = /** @type {NodeListOf<HTMLImageElement>} */ (root.querySelectorAll('.home-hero__image'));
  if (!heroImages.length) return;

  document.documentElement.classList.add('hero-media-enhanced');

  heroImages.forEach((image) => {
    if (image.dataset.heroMediaReady !== undefined) return;
    image.dataset.heroMediaReady = '';

    const markLoaded = () => window.requestAnimationFrame(() => image.classList.add('is-loaded'));
    const decodeAndReveal = () => {
      const decode = image.decode;

      if (typeof decode === 'function') {
        Promise.resolve(decode.call(image)).catch(() => undefined).then(markLoaded);
      } else {
        markLoaded();
      }
    };

    if (image.complete && image.naturalWidth) {
      decodeAndReveal();
    } else {
      image.addEventListener('load', decodeAndReveal, { once: true });
      image.addEventListener('error', markLoaded, { once: true });
    }
  });
}

enableHeroMedia();

document.addEventListener('shopify:section:load', (event) => enableHeroMedia(/** @type {Element} */ (event.target)));
